export default __webpack_public_path__ + "static/media/CELULAR.6a6c9662.png";